import { render, staticRenderFns } from "./UserLocalization.vue?vue&type=template&id=43478a60"
import script from "./UserLocalization.vue?vue&type=script&lang=js"
export * from "./UserLocalization.vue?vue&type=script&lang=js"
import style0 from "./UserLocalization.vue?vue&type=style&index=0&id=43478a60&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43478a60')) {
      api.createRecord('43478a60', component.options)
    } else {
      api.reload('43478a60', component.options)
    }
    module.hot.accept("./UserLocalization.vue?vue&type=template&id=43478a60", function () {
      api.rerender('43478a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/siteheaderstandard/assets/frontend/components/UserLocalization.vue"
export default component.exports